<template>
  <el-dialog
    :modal-append-to-body="false"
    :append-to-body="true"
    title="详情"
    :visible.sync="dialogVisible"
    width="80%"
    top="2%"
  >
    <div style="height: calc(100% - 80px)">
      <el-card class="box-card" style="margin-bottom: 5px">
        <h2 style="margin-bottom: 20px">Address Information</h2>
        <el-form ref="form" :model="form" label-width="100px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="Last Name:">
                {{ form.lastname }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="First/Middle:">
                {{ form.firstname }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Salutation:">
                {{ form.salutation }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Alt. Name:">
                {{ form.altName }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Company:">
                {{ form.company }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Job Title:">
                {{ form.job }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Tel:">
                {{ form.tel }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Remark:">
                {{ form.remark }}
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
      <el-card
        class="box-card"
        style="margin-bottom: 20px; height: calc(100% - 340px)"
      >
        <h2 style="margin-bottom: 20px">Room Information</h2>
        <div class="room-list scroll-bar">
          <el-row
            v-for="i in form.rooms"
            :key="i.id"
            style="border: solid 1px #efefef; height: auto; font-size: 14px"
          >
            <el-col style="background-color: #67c23a; padding: 10px" :span="24">
              <el-row style="line-height: 30px">
                <el-col :span="4">
                  <el-row>
                    <span
                      tyle="display: inline-block;text-align: right; width: 80px;"
                    >
                      Room Type:
                    </span>
                    {{ i.roomTypeDisplay }}
                  </el-row>
                </el-col>
                <el-col :span="7">
                  <el-row>
                    <span
                      style="
                        display: inline-block;
                        text-align: right;
                        width: 70px;
                      "
                    >
                      Amount:
                    </span>
                    {{ i.amount }}
                  </el-row>
                </el-col>
                <el-col :span="13">
                  <el-row>
                    <span
                      style="
                        display: inline-block;
                        text-align: right;
                        width: 120px;
                      "
                    >
                      Arrival/Departure:
                    </span>
                    <el-date-picker
                      disabled
                      v-model="i.date"
                      size="small"
                            type="daterange"
      :clearable="false"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    >
                    </el-date-picker>
                  </el-row>
                </el-col>
                <el-col :span="4">
                  <el-row>
                    <span
                      style="
                        display: inline-block;
                        text-align: right;
                        width: 80px;
                      "
                    >
                      Night:
                    </span>
                    {{ (i.night = getDaysBetween(i.date[0], i.date[1])) }}
                  </el-row>
                </el-col>
                <el-col :span="7">
                  <el-row>
                    <span
                      style="
                        display: inline-block;
                        text-align: right;
                        width: 70px;
                      "
                    >
                      Price:
                    </span>
                    {{ i.rate }}
                  </el-row>
                </el-col>
                <el-col :span="13">
                  <el-row>
                    <span
                      style="
                        display: inline-block;
                        text-align: right;
                        width: 120px;
                      "
                    >
                      Rate:
                    </span>
                    {{ moneyStr(i.rate * i.night * i.amount) }}
                  </el-row>
                </el-col>
              </el-row>
              <el-row v-if="i.message !== ''">
                <span style="color: red" class="message-span">
                  {{ i.message }}
                </span>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </el-card>
      <el-col :span="24" style="font-size: 14px">
        Total Rate: {{ moneyStr(totalRate) }}
      </el-col>
    </div>
  </el-dialog>
</template>
<script>
import { getDetail } from "@/api/guest/list";
export default {
  components: {},
  data() {
    return {
      dialogVisible: false,
      loading: false,
      id: 1,
      form: {
        lastname: "",
        firstname: "",
        salutation: "",
        altName: "",
        company: "",
        job: "",
        tel: "",
        rooms: [],
        remark: ""
      },
      roomType: "",
      hasMessage: false,
      messageClass: "message-class",
      commonClass: "delbtn-class"
    };
  },
  computed: {
    totalRate() {
      return this.form.rooms.reduce((total, item) => {
        return total + item.amount * item.rate * item.night;
      }, 0);
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true;
      getDetail({ bookingCode: row.code }).then(res => {
        this.form = {
          lastname: res.data.LastName,
          firstname: res.data.FirstName,
          salutation: res.data.Salutation,
          altName: res.data.AltName,
          company: res.data.Company,
          job: res.data.JobTitle,
          tel: res.data.Tel,
          remark: res.data.Remark,
          rooms: res.data.BookingRoomGroup.map((i, index) => {
            return {
              id: index,
              roomTypeDisplay: i.RoomType,
              amount: i.Amount,
              date: [i.ArrivalDate, i.DepartureDate],
              night: 0,
              rate: i.Rate
            };
          })
        };
      });
    },
    getDaysBetween(dateString1, dateString2) {
      if (!dateString1 || !dateString2) return 0;
      var startDate = Date.parse(dateString1);
      var endDate = Date.parse(dateString2);
      var days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      return days;
    },
    moneyStr(num) {
      const arr = num.toString().split(".");
      arr[1] = arr[1] || "00";
      return arr[0].toLocaleString() + "." + (arr[1] + "00").slice(0, 2);
    }
  }
};
</script>
<style lang="scss" scoped>
.room-list {
  height: calc(100% - 140px);
  margin-top: 20px;
  overflow: auto;
}
</style>
<style lang="scss">
.el-card__body {
  height: 100%;
}
.el-form-item {
  margin-bottom: 5px;
}
.message-class {
  background-color: #f56c6c;
  text-align: center;
  color: white;
  height: 100%;
  line-height: 99px;
  cursor: pointer;
}
.delbtn-class {
  background-color: #f56c6c;
  text-align: center;
  color: white;
  height: 100%;
  line-height: 84px;
  cursor: pointer;
}
.message-span {
  word-break: normal;
  width: auto;
  display: block;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow: hidden;
}
</style>
